import Axios, {AxiosRequestConfig} from "axios";

export interface Credentials {
    loginId: string,
    withKeyToken: string
}

export interface SecondaryAuthorizationData {
    account: Account,
    registrationId: string,
    secondaryIdentifier: SecondaryIdentifier,
    oneTimePassword: string,
    dueDate: string
}

export interface SecondaryIdentifier {
    phoneNumber: string,
    email: string
}

export interface Account{
    accountNumber: string,
    currency: string
}

export interface OTPData {
    oneTimePassword: string,
    account: Account,
    secondaryIdentifier: SecondaryIdentifier
}

const baseUrl = process.env.PUBLIC_URL + "/";

export const onLogin = async (data: Credentials) =>{
  const requestConfig: AxiosRequestConfig = {
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
      },
      method: 'POST',
      url: baseUrl + "api/login",
      data,
      withCredentials: true
  };

  try {
      const {data: response} = await Axios.request(requestConfig);
      return response;
  } catch (e) {
      console.log("Háttér rendszer nem elérhető")
  }

  return null;

};

export const sendSecondaryAuthorizationData = async (data: SecondaryAuthorizationData) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'POST',
        url: baseUrl + "api/store",
        data,
        withCredentials: true
    };

    try {
        const {data: response} = await Axios.request(requestConfig);
        return response;
    } catch (e) {
        console.log("Háttér rendszer nem elérhető")
    }

    return null;
};

export const sendOTP = async (data: OTPData) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'POST',
        url: baseUrl + "api/validate",
        data,

        withCredentials: true
    };

    try {
        const {data: response} = await Axios.request(requestConfig);
        return response;
    } catch (e) {
        console.log("Háttér rendszer nem elérhető")
    }

    return null;

};

export const sendDelete = async (data: SecondaryAuthorizationData) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'POST',
        url: baseUrl + "api/delete",
        data,
        withCredentials: true
    };

    try {
        const {data: response} = await Axios.request(requestConfig);
        return response;
    } catch (e) {
        console.log("Háttér rendszer nem elérhető")
    }

    return null;
};